const LocationMapDialog = ({
  open,
  onClose,
  lat,
  lng,
  address,
  customerName,
}) => {
  // Don't render anything if dialog is closed
  if (!open) return null;

  // Close dialog when clicking outside
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const mapUrl = `https://maps.google.com/maps?q=${lat},${lng}&t=&z=15&ie=UTF8&iwloc=&output=embed`;
  const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        direction: "rtl",
      }}
      onClick={handleOverlayClick}
    >
      <div
        style={{
          background: "white",
          borderRadius: "12px",
          width: "90%",
          maxWidth: "700px",
          maxHeight: "90vh",
          overflow: "hidden",
          boxShadow: "0 24px 38px 3px rgba(0, 0, 0, 0.14)",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "20px 24px",
            borderBottom: "1px solid #e0e0e0",
            backgroundColor: "#fafafa",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "20px",
              fontWeight: "500",
              color: "#1976d2",
            }}
          >
            📍 موقع العنوان
          </div>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              padding: "8px",
              borderRadius: "50%",
              cursor: "pointer",
              fontSize: "18px",
            }}
          >
            ✕
          </button>
        </div>

        {/* Content */}
        <div>
          {/* Address Info */}
          <div
            style={{
              padding: "20px 24px",
              backgroundColor: "#f8f9fa",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            {customerName && (
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  marginBottom: "8px",
                  color: "#333",
                }}
              >
                العميل: {customerName}
              </div>
            )}
            {address && (
              <div
                style={{
                  fontSize: "14px",
                  color: "#666",
                  marginBottom: "8px",
                  lineHeight: "1.5",
                }}
              >
                العنوان: {address}
              </div>
            )}
            <div
              style={{
                fontSize: "13px",
                color: "#888",
                fontFamily: "monospace",
              }}
            >
              الإحداثيات: {lat}, {lng}
            </div>
          </div>

          {/* Map */}
          <div style={{ height: "400px", width: "100%" }}>
            <iframe
              src={mapUrl}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Customer Location"
            />
          </div>
        </div>

        {/* Actions */}
        <div
          style={{
            padding: "16px 24px",
            borderTop: "1px solid #e0e0e0",
            display: "flex",
            justifyContent: "flex-start",
            gap: "12px",
            backgroundColor: "#fafafa",
          }}
        >
          <a
            href={googleMapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              padding: "8px 16px",
              borderRadius: "6px",
              fontSize: "14px",
              fontWeight: "500",
              cursor: "pointer",
              border: "none",
              backgroundColor: "#1976d2",
              color: "white",
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            📍 فتح في خرائط جوجل
          </a>
          <button
            onClick={onClose}
            style={{
              padding: "8px 16px",
              borderRadius: "6px",
              fontSize: "14px",
              fontWeight: "500",
              cursor: "pointer",
              backgroundColor: "transparent",
              color: "#1976d2",
              border: "1px solid #1976d2",
            }}
          >
            إغلاق
          </button>
        </div>
      </div>
    </div>
  );
};

export default LocationMapDialog;
